/** ***********
*
* <dev-tools.model.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  pranshushrivastav [pranshu.shrivastav@soprasteria.com]
*
* All rights reserved.
**************/

import { Asset } from './asset';
import { Family } from './family';
import { SignalSourceProviderValues } from './signal-source';
import { Zone } from './zone';

export interface JigName {
    section_msn: Asset['sectionMsn'];
}

export interface TransportMeans {
    asset_id: Asset['id'];
    asset_name: Asset['name'];
    family_id: Family['id'];
    family_name: Family['name'];
}

export interface PlannedLine {
    jig_name: JigName;
    operation_type: string;
    planned_location: Zone['id'];
    planned_time: string;
    transport_family_id: Family['id'];
    transport_means: TransportMeans;
}

export enum EventType {
    location = 'location',
    state = 'state',
    data = 'data',
    zone = 'zone',
}

export enum AswarmStatus {
    enter = 'ENTER',
    exit = 'EXIT',
}

export enum EventState {
    stop = 'STOP',
    start = 'START',
    otm = 'OTM',
}

export type EventDev<T = EventType> = {
    assetId: string;
    provider: SignalSourceProviderValues;
    status?: string;
    type: T;
} & (
    {
        type: EventType.data,
        item: {
            data: string;
        };
    } | {
        type: EventType.location;
        item: {
            lat: number;
            lng: number;
        };
    } | {
        type: EventType.state;
        item: {
            state: EventState;
        };
    } | {
        type: EventType.zone;
        item: {
            zone: string;
            state: EventState;
            accuracy: number;
        };
    }
);
